import React from 'react';
import { Form, Pagination } from 'react-bootstrap';

import { useTypedProjectCostContext } from '../useTypedProjectCostContext';
import type { CostTableKey } from '../types';
import { PAGE_SIZE_OPTIONS } from '../utils';

type TableControlsProps = {
  tableKey: CostTableKey;
  placeholder: string;
  totalItems: number;
  totalPages: number;
  currentPage: number;
};

const TableControls: React.FC<TableControlsProps> = ({
  tableKey,
  placeholder,
  totalItems,
  totalPages,
  currentPage,
}) => {
  const { tableStates, updateTableState } = useTypedProjectCostContext<{
    tableStates: Record<CostTableKey, { query: string; page: number; pageSize: number }>;
    updateTableState: (key: CostTableKey, patch: Partial<{ query: string; page: number; pageSize: number }>) => void;
  }>();

  return (
    <div className="cost-table-controls">
      <Form.Control
        size="sm"
        type="text"
        placeholder={placeholder}
        value={tableStates[tableKey].query}
        onChange={(e) => updateTableState(tableKey, { query: e.target.value, page: 1 })}
      />
      <div className="cost-table-controls__meta">
        <small className="text-muted">{totalItems} registro(s)</small>
        <Form.Select
          size="sm"
          value={String(tableStates[tableKey].pageSize)}
          onChange={(e) => updateTableState(tableKey, { pageSize: Number(e.target.value), page: 1 })}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={`${tableKey}-size-${size}`} value={size}>{size}/página</option>
          ))}
        </Form.Select>
      </div>
      <Pagination size="sm" className="mb-0">
        <Pagination.Prev
          onClick={() => updateTableState(tableKey, { page: Math.max(1, currentPage - 1) })}
          disabled={currentPage <= 1}
        />
        <Pagination.Item active>{`${currentPage}/${totalPages}`}</Pagination.Item>
        <Pagination.Next
          onClick={() => updateTableState(tableKey, { page: Math.min(totalPages, currentPage + 1) })}
          disabled={currentPage >= totalPages}
        />
      </Pagination>
    </div>
  );
};

export default TableControls;
